import React, { useEffect, useMemo,useState,useCallback } from "react";
import PageTitle from "../../layouts/PageTitle";
import { ToastContainer } from "react-toastify";
import { Button } from "react-bootstrap";
import Table from "../../components/table/ReactTable/Table";
import { useDispatch, useSelector } from "react-redux";
import { productActions } from "../../../_store";
import { ColumnFilter } from "../../components/table/ReactTable/ColumnFilter";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import generatePDF from "../../components/export/generatePDF";
import generateXlsx from "../../components/export/generateXlsx";
import { HandleArchiveProduct } from "./HandleArchiveProduct";

function ArchiveProducts() {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const dispatch = useDispatch();
  const archivedProduct = useSelector((x) => x?.product?.archivedProductList);
  const isLoading = useSelector((x) => x.product.isLoading);
  const currentUser = useSelector((x) => x.auth.user);

   const [finalTableData, setFinalTableData] = useState([]);

     const handleTableDataUpdate = useCallback((data) => {
        setFinalTableData(data);
      }, []);

  useEffect(() => {
    showLoader();
    dispatch(productActions.archivedProduct());
  }, []);

  useEffect(() => {
    if (isLoading) {
      hideLoader();
    }
  }, [isLoading]);

  const PRODUCTS_COLUMNS = [
    {
      Header: "Warehouse",
      Footer: "Warehouse",
      accessor: "WareHouseNumber",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Category",
      Footer: "Category",
      accessor: "CategoryName",
      justify: "center",
      Filter: ColumnFilter,
    },

    {
      Header: "Product Name",
      Footer: "Product Name",
      accessor: "ProductName",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "SKU",
      Footer: "SKU",
      accessor: "SKU",
      justify: "center",
      Filter: ColumnFilter,
    },

    {
      Header: "Package Type",
      Footer: "Package Type",
      accessor: "PackageType",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Location",
      Footer: "Location",
      accessor: "Location",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Stock Quantity",
      Footer: "Stock Quantity",
      accessor: "StockQuantity",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Created Date",
      Footer: "Created Date",
      accessor: "CreatedDateString",
      justify: "center",
      fieldType: "Date",
      Filter: ColumnFilter,
    },
    {
      Header: "Website",
      Footer: "Website",
      accessor: "Woocommerce",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "",
      Footer: "",
      accessor: "ProductID",
      disableFilters: true,
      Cell: ({ row }) => {
        return (
          <>
            <div className="d-flex">
           {currentUser.UserTypeID !==8 &&(
              <div
                onClick={() => setProductAsUnArchive(row.original)}
                className="btn btn-primary shadow btn-xs sharp me-1 cursor-pointer"
                title="Unarchive"
              >
                <i className="bi bi-box-arrow-up"></i>
              </div>
           )}
            </div>
          </>
        );
      },
    },
  ];

  const columns = useMemo(() => PRODUCTS_COLUMNS, []);

  const generateColumns = [
    {
      header: "Warehouse",
      dataKey: "WareHouseNumber",
    },
    {
      header: "Category",
      dataKey: "CategoryName",
    },
    {
      header: "Product Name",
      dataKey: "ProductName",
    },
    {
      header: "SKU",
      dataKey: "SKU",
    },
    {
      header: "Package Type",
      dataKey: "PackageType",
    },

    {
      header: "Location",
      dataKey: "Location",
    },
    {
      header: "Stock Quantity",
      dataKey: "StockQuantity",
    },
    {
      header: "Created Date",
      dataKey: "CreatedDateString",
    },
    {
      header: "Website",
      dataKey: "Woocommerce",
    },
  ];

  const handleClickPDF = () => {
    let title = "Archive Products";

    const columnStyles = {
      WareHouseNumber: { halign: "center", cellWidth: 30 },
      CategoryName: { halign: "center", cellWidth: 35 },
      ProductName: { halign: "center", cellWidth: 40 },
      SKU: { halign: "center", cellWidth: 35 },
      PackageType: { halign: "center", cellWidth: 26 },
      Location: { halign: "center", cellWidth: 26 },
      StockQuantity: { halign: "center", cellWidth: 26 },
      CreatedDateString: { halign: "center", cellWidth: 26 },
      Woocommerce: { halign: "center",cellWidth: 26 },
    };

   
      generatePDF(finalTableData, generateColumns, true, title, columnStyles
    );
  };

  const handleClickExcel = () => {
    let title = "Archive Products";
    let generateExcelColumns = [
      "Warehouse",
      "Category",
      "Product Name",
      "SKU",
      "Package Type",
      "Location",
      "Stock Quantity",
      "Created Date",
      "Website",
    ];
    let new_productReports =
      finalTableData &&
      finalTableData?.map(function (obj) {
        return {
          WareHouseNumber: obj.WareHouseNumber,
          CategoryName: obj.CategoryName,
          ProductName: obj.ProductName,
          SKU: obj.SKU,
          PackageType: obj.PackageType,
          Location: obj.Location,
          StockQuantity: obj.StockQuantity,
          CreatedDateString: obj.CreatedDateString,
          Woocommerce: obj.Woocommerce,
        };
      });

    generateXlsx(new_productReports, generateExcelColumns, title);
  };

  const setProductAsUnArchive = (values) => {
    HandleArchiveProduct(
      values,
      "",
      " Are you Sure want to Unarchive this Product?",
      "publish",
      dispatch,
      showLoader,
      hideLoader,
      1
    );
  };

  return (
    <>
      <div>
        <PageTitle activeMenu="Archive Products" motherMenu="Products" />
        <ToastContainer />
        <div className="card">
          <div className="card-header">
            <h4 className="card-title header-title">Archive Product List</h4>
            <div className="float-sm-end">
              {archivedProduct && archivedProduct.length > 0 && (
                <>
                  <Button
                    className="me-2"
                    variant="danger btn-rounded"
                    onClick={handleClickPDF}
                  >
                    <span className="btn-icon-start text-danger">
                      <i className="fa fa-solid fa-file-pdf"></i>
                    </span>
                    PDF
                  </Button>
                  <Button
                    className="me-2"
                    variant="secondary btn-rounded"
                    onClick={handleClickExcel}
                  >
                    <span className="btn-icon-start text-secondary">
                      <i className="fa fa-regular fa-file-excel"></i>
                    </span>
                    Excel
                  </Button>
                </>
              )}
            </div>
          </div>
          <div className="card-body">
            <Table columns={columns} data={archivedProduct} onDataUpdate={handleTableDataUpdate} />
          </div>
        </div>
      </div>
      {loader}
    </>
  );
}

export default ArchiveProducts;
